import { useQuery } from '@tanstack/react-query'

import { getDraftPaymentRequestsOnlyCreatedOwn } from '@src/api'
import { DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchDraftPaymentRequestsOnlyCreatedOwn = (
  params: DefaultApiGetDraftPaymentRequestsOnlyCreatedOwnRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getDraftPaymentRequestsOnlyCreatedOwn(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_DRAFT_PAYMENT_REQUESTS_ONLY_CREATED_OWN,
      params,
    ],
  })
}
